import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// i18n
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG Modules
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';
import { BadgeModule } from 'primeng/badge';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

// Shared Components
import { EntityCardComponent } from './components/entity-card/entity-card.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { SportBadgeComponent } from './components/sport-badge/sport-badge.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { DocumentUploaderComponent } from './components/document-uploader/document-uploader.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { LoadingSkeletonComponent } from './components/loading-skeleton/loading-skeleton.component';
import { StatCardComponent } from './components/stat-card/stat-card.component';

@NgModule({
  declarations: [
    EntityCardComponent,
    SportBadgeComponent,
    SearchBarComponent,
    DocumentUploaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    TooltipModule,
    FileUploadModule,
    BadgeModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    CardModule,
    TagModule,
    DropdownModule,
    CalendarModule,
    ProgressSpinnerModule,
    MessageModule,
    TabViewModule,
    CheckboxModule,
    MultiSelectModule,
    DialogModule,
    ToastModule,
    ConfirmDialogModule,
    // Standalone Components
    StatusBadgeComponent,
    PageHeaderComponent,
    EmptyStateComponent,
    LoadingSkeletonComponent,
    StatCardComponent
  ],
  exports: [
    // Modules
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    TooltipModule,
    FileUploadModule,
    BadgeModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    CardModule,
    TagModule,
    DropdownModule,
    CalendarModule,
    ProgressSpinnerModule,
    MessageModule,
    TabViewModule,
    CheckboxModule,
    MultiSelectModule,
    DialogModule,
    ToastModule,
    ConfirmDialogModule,
    // Components
    EntityCardComponent,
    StatusBadgeComponent,
    SportBadgeComponent,
    SearchBarComponent,
    DocumentUploaderComponent,
    PageHeaderComponent,
    EmptyStateComponent,
    LoadingSkeletonComponent,
    StatCardComponent
  ]
})
export class SharedModule {}
